
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 10a2 2 0 11-.001 4.001A2 2 0 0112 10zm7 0a2 2 0 11-.001 4.001A2 2 0 0119 10zM5 10a2 2 0 11-.001 4.001A2 2 0 015 10z"}})])
          )
        }
      }
    